import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService, QueryParameter } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';

@Component({
  selector: 'yt-izvod-stavka-update-container',
  templateUrl: './izvod-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class IzvodStavkaUpdateContainerComponent <T extends BaseEntity> extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

tempItems: List<T>
maxRB: number = 0;
  TransferMaxRB: List<List<QueryParameter>>
  @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

setItems(items){
   this.tempItems = items;
   this.maxRB=0;
    if(this.tempItems && this.tempItems.size > 0){
      this.tempItems.forEach((item :T) =>{
        if (item['RB'] > this.maxRB)
          this.maxRB=item['RB'];      
      })
    }

    setTimeout(() => {
      let parameterList: List<QueryParameter> = List([new QueryParameter('MaxRB', this.maxRB+1)]);
      this.TransferMaxRB = List([]);
      this.TransferMaxRB = this.TransferMaxRB.set(0, parameterList);
    }, 0);

}
  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
    }
  }
}
